
import './../scss/customokr.scss'
import './../scss/custom_fields.scss'
import React, { useRef, useEffect, useState, useCallback } from 'react'
import styled from "styled-components";
import Clear from '@material-ui/icons/Clear';
import CustomName from "./CustomName"
import { FieldTypeAttributes } from "./../utils/constants"
import { setCustomFieldValue } from "./../utils/customFieldsDisplayUtils"
import { Dropdown, IconButton, Checkbox } from '@workboard/wobo-ui';
import { HtmlInput } from '@workboard/ui-okr';
import { useTranslation } from 'react-i18next';
import { normalizeStoredValueToHtml } from '../utils/normalizeStoredValueToHtml';
import { useClosedKrLock } from '../../okr/wizard/closedKrLock.context';

// Prefer the in-progress value from customData; fall back to savedValue only when .text is
// undefined. A stored '' means the user cleared the field — return it as-is, don't revert.
const getStoredFieldText = (fieldData, customData) => {
  const fieldText = customData?.[fieldData.cat_id]?.['customFields']?.[fieldData.id]?.text;
  if (fieldText !== undefined) return fieldText;
  const saved = fieldData.savedValue?.value;
  return (saved && (Array.isArray(saved) ? saved[0] : saved)) ?? '';
};

const StyledRemoveIconButton = styled(IconButton)`
width: 21px;
height: 21px;
svg {
  width: 24px;
  height: 24px;
}
&.MuiButtonBase-root{
  vertical-align: top;
}
`;
const StyledCheckbox = styled(Checkbox)`
.browse-checkbox {
  width: 10px;
  height: 0px;
}
.MuiButtonBase-root {
  margin-left: 0px;
	padding: 0px;
}

svg {
width: 24px;
height: 24px;
}
`;
const StyledDropdown = styled(Dropdown)`
  width:45%;
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-root {
    background-color: #f2f2f2 !important;
    border: 1px solid rgba(0,0,0,0.06);
    height: 38px;
  }
  #unit-measure-dropdown{
    min-width: 177px;
  }
  #cal-overall-dropdown{
    min-width: 226px;
  }
  #select-day-dropdown{
    min-width: 120px;
  }
}
`;


const CustomOkr = (props) => {
  const catIds = props.customData ? Object.keys(props.customData) : "0";
  const [viewP, setViewP] = useState(catIds);
  const isRequiredCustomOkrFiledRef = useRef(props.isRequiredCustomOkrFiled);
  isRequiredCustomOkrFiledRef.current = props.isRequiredCustomOkrFiled;
  const isClosedKr = useClosedKrLock();

  // Keep newly loaded categories expanded when customData updates after owner/team changes.
  useEffect(() => {
    if (!props.customData) return;
    const nextCategoryIds = Object.keys(props.customData);
    setViewP((prevViewP) => {
      const existing = Array.isArray(prevViewP) ? prevViewP.map(String) : [];
      const merged = Array.from(new Set([...existing, ...nextCategoryIds.map(String)]));
      return merged;
    });
  }, [props.customData]);

  // Locked fields can't be filled in, so a Closed KR must not report required ones as missing.
  useEffect(() => {
    if (!props.customData || isClosedKr) return;
    isRequiredCustomOkrFiledRef.current?.(props.customData);
  }, [props.customData, isClosedKr]);

  return (
    <div >
      {props.customData && Object.keys(props.customData).map(k => props.customData[k]).map(dataVal => (
        <div
          className="marginobj">
          {dataVal.id != 0 &&
            <div className="cutomobj" id="cutomobj" data-testid="CustomObjName">
             {dataVal.customFields &&
              <div data-testid="arrowDownbtn" className={viewP.includes(dataVal.id) ? 'arrowDown arrowMarging arrowRotate' : "arrowDown arrowMarging"}

                key={`Obj${dataVal.id}`}
                onClick={event => {
                  if (viewP.find((u) => u == dataVal.id)) {

                    setViewP(viewP.filter(
                      (u) => u != dataVal.id

                    ))
                  } else {
                    setViewP([...viewP, dataVal.id])
                  }


                }} />
              }
              <p style={{marginLeft: !dataVal.customFields &&' 15px'}}>{dataVal.name}</p>
            </div>
            }

          {

            (
              props.isCustomSave.find((u) => u == dataVal.id) ||
              viewP.find((u) => u == dataVal.id))
            && (
              <div >
                {
                  dataVal.customFields && Object.keys(dataVal.customFields).map(k => dataVal.customFields[k]).sort((a,b)=>{
                   return a.sorting_order-b.sorting_order;
                  }).map((fieldData) => {
                    return (
                      <div>
                        <div><a><CustomName title={fieldData.name} tooltip={fieldData.tooltip_description} isReq={fieldData.is_required} /></a></div>
                        <div><CustomField item={props.item} goalDetails={props.goalDetails} fieldData={fieldData} key={`field${fieldData.id}`} customData={props.customData} isRequiredCustomOkrFiled={props.isRequiredCustomOkrFiled} isCustomSave={props.isCustomSave} setcustomData={props.onCustomDataChange} customFiledRequired={props.customFiledRequired} renderError={props.renderError}></CustomField></div>
                      </div>
                    )
                  })

                }

              </div>
            )}
        </div>))}

    </div>
  )
}
const MultiSelectOptionsDropdown = ({
  dropDownVisible,
  menuOption,
  getFilteredOptions,
  multySelectOption,
  handleMultySelect,
  fieldData,
  t,
}) => {
  const filteredOptions = getFilteredOptions();
  const hasFilteredOptions = filteredOptions.length > 0;

  return (
    <div className="CateScroll_" id="searchByTeamid" ref={menuOption}>
      {dropDownVisible && (
        <>
          {hasFilteredOptions ? (
            filteredOptions.map((eachCat) => {
              const originalIndex = multySelectOption.findIndex((option) => option.name === eachCat.name);
              return (
                <div className="catLists" key={`Cat${originalIndex}`}>
                  <div
                    className="myAlign"
                    data-testid="custom-myAlign"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      margin: '3px',
                    }}
                    key={`SubCat${originalIndex}`}
                  >
                    <StyledCheckbox
                      className="browse-checkbox"
                      onChange={(event) => {
                        handleMultySelect(originalIndex, fieldData.cat_id, fieldData.id);
                      }}
                      type="checkbox"
                      isChecked={eachCat.status}
                      id={'Cat_' + originalIndex}
                      label={eachCat.name}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                padding: '12px 16px',
                color: '#999',
                textAlign: 'center',
                fontSize: '14px',
              }}
            >
              {t('No options match your search')}
            </div>
          )}
        </>
      )}
    </div>
  );
};


const CustomField = (props,) => {
  const [dropDownVisible, setDropDownVisible] = useState(false);
  const menuOption = useRef(null)
  const [multySelectOption, setMultySelectOption] = useState([]);
  const [dropdownVal, setDropdownVal] = useState(null);
  const [searchInput, setSearchInput] = useState('');
  const { t } = useTranslation()
  const isClosedKr = useClosedKrLock();

  useEffect(() => {
    const handler = (e) => {
      if (menuOption.current && !menuOption.current.contains(e.target)) {
        setDropDownVisible(false)
        setSearchInput('')
        if (menuOption.current) {
          menuOption.current.classList.remove('searchByTeamOrGroup');
        }
      }
    }
    document.addEventListener('click', handler, true)
    return () => {
      document.removeEventListener('click', handler, true)
    }
  }, [menuOption])

  const resetDropDown = (id, field) => {
    if(props.fieldData.field_type_id == FieldTypeAttributes.ATTRIBUTE_DROPDOWN){
      setDropdownVal(null);
      const newData = setCustomFieldValue(props.customData, id, field, null);
      props.setcustomData(newData);
      props.isRequiredCustomOkrFiled(newData, field);
    }
  }

  const handleChangetext = (e, id, field) => {
    if(props.fieldData.field_type_id == FieldTypeAttributes.ATTRIBUTE_DROPDOWN){
      setDropdownVal(e.target.value);
      const value = props.fieldData.fieldValues[Number(e.target.value)].value;
        const newData = setCustomFieldValue(props.customData, id, field, value);
        props.setcustomData(newData);
        props.isRequiredCustomOkrFiled(newData, field);
    } else {
      const newData = setCustomFieldValue(props.customData, id, field, e.target.value);
      props.setcustomData(newData);
      props.isRequiredCustomOkrFiled(newData, field);
    }
  }
  useEffect(() => {
    let multiselect = []
    // Validation checks only apply to multi-select fields
    if (
      props.fieldData.field_type_id ==
      FieldTypeAttributes.ATTRIBUTE_MULTI_SELECT
    ) {
      let fieldValueTemp = Object.values(props.fieldData.fieldValues || [])
      const validFieldValues = fieldValueTemp.map(fv => fv.value);
      // Prefer current value from customData (preserve selection when switching KR type); fall back to savedValue only when current is undefined.
      const currentMulti = props.customData?.[props.fieldData?.cat_id]?.['customFields']?.[props.fieldData?.id]?.text ?? props.fieldData?.text;
      let selectedNames = [];
      if (Array.isArray(currentMulti) && currentMulti.length > 0) {
        selectedNames = currentMulti
          .map(x => (typeof x === 'object' && x != null && x.name != null ? x.name : x))
          .filter(val => validFieldValues.includes(val));
      } else if (currentMulti === undefined && props.fieldData.savedValue && props.fieldData.savedValue.value) {
        const savedValue = Array.isArray(props.fieldData.savedValue.value)
          ? props.fieldData.savedValue.value
          : [props.fieldData.savedValue.value];
        selectedNames = savedValue.filter(val => validFieldValues.includes(val));
      }
      // else: currentMulti null or [] (user cleared) -> selectedNames stays []

      let tempdata = new Array(fieldValueTemp.length).fill('')
      if (selectedNames.length > 0) {
        for (let i = 0; i < fieldValueTemp.length; i++) {
          if (selectedNames.includes(fieldValueTemp[i].value)) {
            tempdata[i] = fieldValueTemp[i].value
          } else {
            tempdata[i] = ''
          }
        }
      }

      // Build multiselect array - always build it even if no valid selected values
      for (let i = 0; i < fieldValueTemp.length; i++) {
        if (fieldValueTemp[i].value == tempdata[i]) {
          multiselect.push({
            name: fieldValueTemp[i].value,
            status: true,
          })
        } else {
          multiselect.push({
            name: fieldValueTemp[i].value,
            status: false,
          })
        }
      }
    }
    setMultySelectOption(multiselect)

    // Validation checks only apply to dropdown fields
    if(props.fieldData.field_type_id == FieldTypeAttributes.ATTRIBUTE_DROPDOWN){
      const fieldValues = props.fieldData.fieldValues || [];
      const currentTextForDropdown = props.customData?.[props.fieldData.cat_id]?.['customFields']?.[props.fieldData.id]?.text ?? props.fieldData?.text;
      let indexToSet = null;
      // Prefer current customData.text when present (preserve value when switching KR type or after parent rehydration)
      if (currentTextForDropdown !== undefined && currentTextForDropdown !== null && currentTextForDropdown !== '') {
        const idx = fieldValues.findIndex(i => i.value == currentTextForDropdown);
        if (idx !== -1) indexToSet = idx;
      } else if (currentTextForDropdown === undefined) {
        // No current value in customData (e.g. initial load); fall back to savedValue
        if (props.fieldData.savedValue && props.fieldData.savedValue.value) {
          const savedValue = Array.isArray(props.fieldData.savedValue.value)
            ? props.fieldData.savedValue.value[0]
            : props.fieldData.savedValue.value;
          if (savedValue) {
            const value = fieldValues.findIndex(i => i.value == savedValue);
            if (value !== -1) indexToSet = value;
          }
        }
      }
      // else: currentTextForDropdown is null or '' (user cleared) THEN keep indexToSet null
      setDropdownVal(indexToSet);
    }
  }, [props.customData, props.fieldData?.cat_id, props.fieldData?.id])

  const handleMultySelect = (index, id, field) => {
    const next = multySelectOption.map((opt, i) =>
      i === index ? { name: opt.name, status: !opt.status } : opt
    );
    setMultySelectOption(next);
    const unique_arr = next.filter((ele) => ele.status === true);
    const newData = setCustomFieldValue(props.customData, id, field, unique_arr);
    props.setcustomData(newData);
    props.isRequiredCustomOkrFiled(newData, field);
  }

  const handleSearchInputChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchInput(value);
  }

  const getFilteredOptions = () => {
    if (!searchInput.trim()) {
      return multySelectOption;
    }
    return multySelectOption.filter((option) =>
      option.name.toLowerCase().includes(searchInput.toLowerCase())
    );
  }

  if (props.fieldData.field_type_id == FieldTypeAttributes.ATTRIBUTE_DROPDOWN) {
    const selectedText = props.fieldData?.text;
    return (
      <div>
        {/* <-------------------Field_Type  DropDown--------------------------> */}
        <div >
          <StyledDropdown
            data-testid="custom-styled-dropdown"
            aria-labelledby="cal-overall"
            autoMenuWidth
            required
            disabled={isClosedKr}
            style={{
              border: (
                props.isCustomSave.find((u) => u == props.fieldData.id)
              ) ? "1px solid #d93630" : 'none'
            }}
            onChange={(e) => {
              handleChangetext(e, props.fieldData.cat_id, props.fieldData.id)
            }}
            value={dropdownVal}
            optionTitleProp="name"
            optionValueProp="value"
            options={Object.keys(props.fieldData.fieldValues).map((k,index) =>{ return {value : index, name : props.fieldData.fieldValues[k].value }})}
            MenuProps={{
              style: {
                zIndex: '1500000'
              },
            }}
          />
          {(props.isCustomSave.find((u) => u == props.fieldData.id)) ? <div>
            {
              props.renderError("customokr")
            }
          </div> : ""}

        </div>

        { (dropdownVal !== undefined && dropdownVal != null) ?
          <div className="selectedObj" data-testid="selected-DrpOption" >
              <div className="selectedMyAlign selCatHigh">
                <div className="inLineBlk alignOdjLists">
                  <div className="alignOdjtex" id={`selected-dropdown-Option`}>{selectedText}</div>
                </div>
                <StyledRemoveIconButton
                    data-testid="crossmark"
                    aria-label='Remove'
                    // defaultValue={props.fieldData.savedValue}
                    aria-describedby={`selected-dropdown-Option`}
                    id={`removeDrpOptionBtn`}
                    isDisabled={isClosedKr}
                    onClick ={(e) =>
                      {resetDropDown(props.fieldData.cat_id, props.fieldData.id)}
                    }
                >
                  <Clear />
                </StyledRemoveIconButton>
              </div>
          </div>
          : ''
         }
        </div>

    )
  } else if (props.fieldData.field_type_id == FieldTypeAttributes.ATTRIBUTE_MULTI_SELECT) {
    return (
      <div
        id="myAlign"
        className="dropdown"

      >
        <input
          type="text"
          id="id-teams-or-bizGroup-txt"
          data-testid="attr-Multi-select"
          placeholder={t("Select From Options")}
          disabled={isClosedKr}
          className="objCategorySearch"
          value={searchInput}
          onChange={handleSearchInputChange}
          onClick={() => {
            setDropDownVisible(true);
            if (menuOption.current) {
              menuOption.current.classList.add('searchByTeamOrGroup');
            }
          }}
          style={{
            border: (
              props.isCustomSave.find((u) => u == props.fieldData.id)
            ) ? "1px solid #d93630" : 'none'
          }}
          autoFocus={false}
          required={true}
          error={true}
        />
        {(
          props.isCustomSave.find((u) => u == props.fieldData.id)) ? <div>
          {
            props.renderError("customokr")
          }
        </div> : ""}
        <MultiSelectOptionsDropdown 
          dropDownVisible={dropDownVisible}
          menuOption={menuOption}
          getFilteredOptions={getFilteredOptions}
          multySelectOption={multySelectOption}
          handleMultySelect={handleMultySelect}
          fieldData={props.fieldData}
          t={t}
        />
        {/* ...............multy.......... */}
        {
          multySelectOption
            ?
            multySelectOption.map((eachSub, index) => (
              eachSub.status ?
                <div className="selectedObj" data-testid="selected-multyOption" key={index}>
                  <div className="selectedMyAlign selCatHigh">
                    <div className="inLineBlk alignOdjLists">
                      <div className="alignOdjtex" id={`selected-multy-Option-${index}`}>{eachSub.name}</div>
                    </div>
                    <StyledRemoveIconButton
                      data-testid="crossmark"
                      aria-label={t('Remove')}
                      // defaultValue={props.fieldData.savedValue}
                      aria-describedby={`selected-multy-Option-${index}`}
                      id={`removeMultyOptionBtn${index}`}
                      isDisabled={isClosedKr}
                      onClick={e =>
                        handleMultySelect(index, props.fieldData.cat_id, props.fieldData.id)
                      }
                    >
                      <Clear />
                    </StyledRemoveIconButton>
                  </div>
                </div> : ''
            ))
            : ""
        }
        {/* .................... */}
      </div>
    )
  } else if (props.fieldData.field_type_id == FieldTypeAttributes.ATTRIBUTE_TEXT_AREA) {
    // HtmlInput is uncontrolled: seed once on mount, onChange keeps customData in sync (as before).
    const storedValue = getStoredFieldText(props.fieldData, props.customData);
    const handleHtmlChange = (html) =>
      handleChangetext({ target: { value: html } }, props.fieldData.cat_id, props.fieldData.id);
    return (
      <div>
        <div
          data-testid="custom-input-textArea"
          className="textAreaCustom"
          style={{
            width: '97.6%',
            border: props.isCustomSave.find((u) => u == props.fieldData.id) ? '1px solid #d93630' : 'none',
          }}
        >
          {/* Stop LinkDialog submit bubbling to wizard <form onSubmit> */}
          <div
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <HtmlInput
              ariaLabel={props.fieldData.name}
              placeHolder={t('Enter field description')}
              baseUrl={wbConfig?.baseUrl || ''}
              disableMentions
              disabled={isClosedKr}
              submitOnBlur
              initialValue={normalizeStoredValueToHtml(storedValue)}
              onChange={handleHtmlChange}
              onSubmit={handleHtmlChange}
            />
          </div>
        </div>
        {props.isCustomSave.find((u) => u == props.fieldData.id) ? <div>{props.renderError('customokr')}</div> : ''}
      </div>
    );
  } else if (props.fieldData.field_type_id == FieldTypeAttributes.ATTRIBUTE_TEXT_FIELD) {
    return (
      <div key="Customtext">
        <input
          data-testid="custom-input-text"
          className="objAlignment aEPermissionList perMissionTeam"
          style={{
            width: '100%',
            border:
              props.customFiledRequired && props.isCustomSave.find((u) => u == props.fieldData.id)
                ? '1px solid #d93630'
                : 'none',
          }}
          isRequired={true}
          placeholder={t('Enter field description')}
          disabled={isClosedKr}
          type="type"
          value={getStoredFieldText(props.fieldData, props.customData)}
          onChange={(e) => handleChangetext(e, props.fieldData.cat_id, props.fieldData.id)}
        ></input>
        {props.isCustomSave.find((u) => u == props.fieldData.id) ? <div>{props.renderError('customokr')}</div> : ''}
      </div>
    );
  }
  else {
    return (
      <div style={{ marginTop: '10px' }}>
        <input
          data-testid="custom-input-text"
          className="objAlignment aEPermissionList perMissionTeam"
          defaultValue={getStoredFieldText(props.fieldData, props.customData)}
          style={{
            width: '100%',
            border:
              props.customFiledRequired && props.isCustomSave.find((u) => u == props.fieldData.id)
                ? '1px solid #d93630'
                : 'none',
          }}
          placeholder={t('Enter Field Discription')}
          disabled={isClosedKr}
          onChange={(e) => handleChangetext(e, props.fieldData.cat_id, props.fieldData.id)}
        ></input>
        {props.isCustomSave.find((u) => u == props.fieldData.id) ? <div>{props.renderError('customokr')}</div> : ''}
      </div>
    );

  }

}

export default CustomOkr
